import React from 'react';
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";

export default function SectionDescription({text, col}) {
    const darkMode = useSelector((state) => state.settings.darkMode);
    const {t} = useTranslation();
    return <div className={darkMode ? ` ${col} section_description light-text` : ` ${col} section_description`}>{t(text)}</div>
}